import { CommentFragment } from '@spotify/confidence-graphql';

import { Anchor } from '../types';

export const toAnchor = (comment: CommentFragment): Anchor | undefined => {
  if (!comment.anchor?.zone?.zone) return undefined;
  return { zone: comment.anchor.zone.zone };
};
